let config = undefined;
let bld = process.env.INSA_BUILD || 'DEVELOPMENT';
let defaultConfig = require('./insaweb.default.' + bld + '.config').appConfig;
let clientConfig = {}
let clientServiceConfig = {}

if (process.env.INSA_CLIENT && process.env.INSA_CLIENT !== '') {
    console.log('Using ' + bld + ' config');
    console.log('Using ' + process.env.INSA_CLIENT + ' application config');
    clientConfig = require('./insa-css/insa-clients/' + process.env.INSA_CLIENT + '/insaweb.config.ts').appConfig;
    if (bld === 'PRODUCTION') {
      clientServiceConfig = require('./insa-css/insa-clients/' + process.env.INSA_CLIENT + '/insaweb.service.config.ts').appConfig;
      console.log('Using ' + process.env.INSA_CLIENT + ' service config');
    }
} else {
    // load standard config file
    console.log('Using default ' + bld + ' config');
}

config = Object.assign({}, defaultConfig, clientConfig, clientServiceConfig);

// console.log(config)

export var appConfig = config


// WEBPACK FOOTER //
// ./insaweb.config.ts